import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardProps, setLengthMin, setLengthMinUndefined, StateProps } from "../../store";
import * as S from "./styles";

const LengthMinInput = ({ id }: Pick<CardProps, "id">) => {
  const currentCard = useSelector((state: StateProps) => state.cards.find((card) => card.id === id));

  const dispatch = useDispatch();

  const setLength = (lengthMin: string) => {
    console.log('setLength', lengthMin)
    if(lengthMin === "") {
      dispatch(setLengthMinUndefined({ cardId: id, lengthMin }));
    }else {
      dispatch(setLengthMin({ cardId: id, lengthMin }));
    }
  }

  const getLength = () => {
    const lengthMin = currentCard?.lengthMin;

    if(lengthMin === undefined || lengthMin === null) {
      return "";
    }

    if (lengthMin || lengthMin === 0) {
      return lengthMin;
    }
    return "";
  }


  return (
    <S.LengthMinDiv>최소 글자 수 <S.LengthMinInput
      id="standard-basic"
      type="number"
      variant="standard"
      value={getLength()}
      onChange={(e) => setLength(e.target.value)}
    /></S.LengthMinDiv>
  );
};

export default LengthMinInput;
